import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-busy"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_PageFooter = _resolveComponent("PageFooter")!
  const _component_PageOverlay = _resolveComponent("PageOverlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "mainPageWrap",
      "aria-busy": _ctx.store.state.loadingCount>0
    }, [
      _withDirectives(_createVNode(_component_router_view, null, null, 512), [
        [_vShow, _ctx.store.state.loadingCount<=0 || _ctx.store.state.initiated]
      ])
    ], 8, _hoisted_1),
    (!_ctx.$route.meta.hideChrome)
      ? (_openBlock(), _createBlock(_component_PageFooter, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_PageOverlay, {
      Loading: _ctx.store.state.loadingCount>0
    }, null, 8, ["Loading"])
  ], 64))
}